import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import useNotifications from '../functions/hooks/useNotifications';
import AnalisisActividad from '../components/graphics/AnalisisActividad';
import CuadrantesPorSemana from '../components/graphics/CuadrantesPorSemana';
import TiempoPorSemana from '../components/graphics/TiempoPorSemana';
import DificultadPorSemana from '../components/graphics/DificultadPorSemana'; // <--- Importa la correcta

const Stadistics = () => {
  const usuarioId = sessionStorage.getItem('usuarioId');
  useNotifications(usuarioId);

  const styles = {
    container: {
      backgroundColor: '#F4F6FA',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
    },
    mainContent: {
      padding: '40px 20px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
      gap: '30px',
      justifyItems: 'center',
    },
    chartBox: {
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '20px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
      transition: 'transform 0.2s ease',
      width: '100%',
      maxWidth: '600px',
      textAlign: 'center',
    },
    chartBoxHover: {
      transform: 'translateY(-5px)',
    },
    title: {
      fontSize: '22px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '16px',
    },
  };

  const handleHover = (e, enter) => {
    e.currentTarget.style.transform = enter ? styles.chartBoxHover.transform : 'none';
  };

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.mainContent}>
        {/* Gráfico 1 */}
        <div
          style={styles.chartBox}
          onMouseEnter={(e) => handleHover(e, true)}
          onMouseLeave={(e) => handleHover(e, false)}
        >
          <h2 style={styles.title}>Análisis de Dificultad Promedio</h2>
          <AnalisisActividad />
        </div>

        {/* Gráfico 2 */}
        <div
          style={styles.chartBox}
          onMouseEnter={(e) => handleHover(e, true)}
          onMouseLeave={(e) => handleHover(e, false)}
        >
          <h2 style={styles.title}>Cuadrantes por Semana</h2>
          <CuadrantesPorSemana />
        </div>

        {/* Gráfico 3 */}
        <div
          style={styles.chartBox}
          onMouseEnter={(e) => handleHover(e, true)}
          onMouseLeave={(e) => handleHover(e, false)}
        >
          <h2 style={styles.title}>Tiempo Total por Semana</h2>
          <TiempoPorSemana />
        </div>

        {/* Gráfico 4 */}
        <div
          style={styles.chartBox}
          onMouseEnter={(e) => handleHover(e, true)}
          onMouseLeave={(e) => handleHover(e, false)}
        >
          <h2 style={styles.title}>Dificultad Promedio y su Tasa de Cambio</h2>
          <DificultadPorSemana />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Stadistics;
